module.exports = __webpack_public_path__ + "img/pedestrain_door.042f0927.png";